<template>
  <div>
    <div class="hospitals hp_flex">
      <div
        v-for="(item, index) in list"
        :style="{
          marginRight: (index - 1) % 3 ? '' : num+'px',
          marginLeft: (index - 1) % 3 ? '' : num+'px',
        }"
        :key="index"
        class="hospital_demo"
        @click="toPage(item.id)"
      >
        <div>
          <img v-if="item.image" :src="base_url + item.image" alt />
          <img v-else src="@/assets/default-img/hospital.png" alt />
          <div class="detail">
            <div class="name">{{ item.name }}</div>
            <div class="tags hp_flex">
              <span v-if="item.levelName" class="tag">
                {{
                item.levelName
                }}
              </span>
              <span v-if="item.adminLevelName" class="tag">
                {{
                item.adminLevelName
                }}
              </span>
              <template v-if="item.typeNames">
                <span
                  v-for="(tag, index) in item.typeNames.split(',')"
                  :key="index"
                  class="tag"
                >{{ tag }}</span>
              </template>
            </div>
            <div class="mobile hp_cz_center">
              <icon-font style="font-size:14px;" type="icon-dianhua01" />
              <span>{{ item.tel }}</span>
            </div>
            <div class="mobile hp_cz_center">
              <icon-font style="font-size:18px" type="icon-location" />
              <span>{{ item.address }}</span>
            </div>
          </div>
        </div>

        <div class="statistics hp_cz_center_s">
          <div>
            累计
            <span>{{ item.registCount }}</span>次预约
          </div>
          <div>
            累计
            <span>{{ item.commentCount }}</span>条评论
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      num: 10,
    };
  },
  methods: {
    toPage(id) {
      this.$router.push("/registered/hospital/" + id);
    },
    sum() {
      let long = document.getElementsByClassName("hospitals")[0].offsetWidth;
      let short = document.getElementsByClassName("hospital_demo")[0]
        .offsetWidth;
      if (Math.floor((long - short * 3) / 2) - 1 > 0) {
        this.num = Math.floor((long - short * 3) / 2) - 1;
      }
    },
  },
  mounted() {
    this.sum();
    window.addEventListener("resize", this.sum);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.sum);
  },
};
</script>
<style lang="less">
.hospitals {
  cursor: pointer;
  flex-wrap: wrap;
  .hospital_demo {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 290px;
    margin-bottom: 30px;
    border-radius: 10px;
    box-shadow: -2px 0px 6px 1px #b5d2f7;
    overflow: hidden;
    img {
      width: 290px;
      height: 240px;
    }
    .detail {
      padding: 12px 20px 0px 20px;
      .name {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
      }
      .tags {
        flex-wrap: wrap;
        .tag {
          margin-right: 6px;
          margin-bottom: 10px;
          font-size: 12px;
          padding: 2px 11px;
          background: #0079fe;
          border-radius: 10px;
          color: #fff;
        }
      }
      .mobile {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        position: relative;

        span {
          margin-left: 15px;
        }
      }
    }
    .statistics {
      padding: 0px 20px 12px 20px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      span {
        font-weight: bold;
        font-size: 16px;
        color: #0079fe;
      }
    }
  }
}
</style>
